import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl} from '@angular/forms';
import { UsersService } from 'src/app/services/users.service';
import {default as codes } from 'src/assets/data/country-codes.json';

@Component({
  selector: 'app-user-info',
  templateUrl: './user-info.component.html',
  styleUrls: ['./user-info.component.scss']
})
export class UserInfoComponent implements OnInit {

  constructor(private userService: UsersService) { }
  public userDetails: FormGroup;
  @Output() onClose:EventEmitter<any> = new EventEmitter();
  @Input() user:any;
  public genderMap: Map<string, string>;
  ngOnInit(): void {
    this.genderMap = new Map([
      ['M' , 'Male'],
      ['F' , 'Female'],
      ['O' , 'Others']]
    )
    this.userDetails = new FormGroup({
      title: new FormControl(this.user?.title),
      firstName: new FormControl(this.user?.firstName),
      lastName: new FormControl(this.user?.lastName),
      dob: new FormControl(this.user?.dob),
      countryCode: new FormControl(''),
      phone: new FormControl(this.user?.phone),
      qualification: new FormControl(this.user?.qualification),
      state: new FormControl(this.user?.state),
      country: new FormControl(this.user?.country),
      pincode: new FormControl(this.user?.pincode),
      address: new FormControl(this.user?.address),
      email: new FormControl(this.user?.email),
      institution: new FormControl(this.user?.institution),
      gender: new FormControl(this.genderMap.get(this.user?.gender))
    });

    for(let i=0;i<codes.length;i++){
      if(codes[i].name == this.userDetails.get('country').value){
        this.userDetails.get('countryCode').setValue(codes[i].dial_code);
        break;
      }
    }
  }

  onClickCancel(){
    this.onClose.emit('close');
  }

}
